import { IDimensions } from '@metrics/VideoElementMetrics';

export enum EMetricsEvents {
  SESSION_ID_RECREATED = 'sessionIdRecreated',
  UPSCALE_CALCULATED = 'upscaleCalculated',
  VIDEO_ELEMENT_DIMENSIONS_CALCULATED = 'videoElementDimensionsCalculated',
}

export interface IMetricsEventsMap {
  [EMetricsEvents.SESSION_ID_RECREATED]: never;
  [EMetricsEvents.UPSCALE_CALCULATED]: { upscaleFactor: number | null };
  [EMetricsEvents.VIDEO_ELEMENT_DIMENSIONS_CALCULATED]: IDimensions;
}

export type TMetricsEventPayload<T extends keyof IMetricsEventsMap> = IMetricsEventsMap[T];
